import React from "react";
import { Box, Portal } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import NoticeboardButton from "../shared/NoticeboardButton";

/** Floats above a handoff screen (and its wizard) to reopen the chat where it was left. */
const BackToChatButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <Portal>
    <Box
      sx={{
        position: "fixed",
        right: 24,
        bottom: 24,
        // Above the notice wizard, which is itself a modal
        zIndex: (theme) => theme.zIndex.modal + 3,
      }}
    >
      <NoticeboardButton
        startIcon={<ChatBubbleOutlineIcon />}
        onClick={onClick}
        sx={{ boxShadow: 6 }}
      >
        Back to chat
      </NoticeboardButton>
    </Box>
  </Portal>
);

export default BackToChatButton;
